import React from 'react';
import ContentLoader from 'react-content-loader';
import {isRTL} from '../../../../../../Localization';

type Props = {
    className?: string;
};

export const Loader = (props: Props) => (
    <ContentLoader
        speed={5}
        width={450}
        height={855}
        viewBox="0 0 450 855"
        backgroundColor="#f4f6f8"
        foregroundColor="#dee7eb"
        style={{flexShrink: 0}}
        rtl={isRTL()}
        {...props}
    >
        <rect x="25" y="10" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="13" rx="3" ry="3" width="121" height="16" />
        <rect x="75" y="36" rx="3" ry="3" width="187" height="14" />
        <rect x="25" y="80" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="83" rx="3" ry="3" width="121" height="16" />
        <rect x="75" y="106" rx="3" ry="3" width="187" height="14" />
        <rect x="25" y="150" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="153" rx="3" ry="3" width="121" height="16" />
        <rect x="334" y="150" rx="3" ry="3" width="62" height="17" />
        <rect x="75" y="176" rx="3" ry="3" width="187" height="14" />
        <rect x="334" y="173" rx="3" ry="3" width="62" height="17" />
        <rect x="25" y="220" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="223" rx="3" ry="3" width="121" height="16" />
        <rect x="75" y="246" rx="3" ry="3" width="187" height="14" />
        <rect x="25" y="290" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="293" rx="3" ry="3" width="121" height="16" />
        <rect x="75" y="316" rx="3" ry="3" width="187" height="14" />
        <rect x="25" y="360" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="363" rx="3" ry="3" width="121" height="16" />
        <rect x="75" y="386" rx="3" ry="3" width="187" height="14" />
        <rect x="25" y="430" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="433" rx="3" ry="3" width="121" height="16" />
        <rect x="334" y="442" rx="3" ry="3" width="62" height="17" />
        <rect x="75" y="456" rx="3" ry="3" width="187" height="14" />
        <rect x="25" y="500" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="503" rx="3" ry="3" width="121" height="16" />
        <rect x="75" y="526" rx="3" ry="3" width="187" height="14" />
        <rect x="25" y="570" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="573" rx="3" ry="3" width="121" height="16" />
        <rect x="75" y="596" rx="3" ry="3" width="187" height="14" />
        <rect x="25" y="640" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="643" rx="3" ry="3" width="121" height="16" />
        <rect x="75" y="666" rx="3" ry="3" width="187" height="14" />
        <rect x="25" y="710" rx="3" ry="3" width="40" height="40" />
        <rect x="75" y="713" rx="3" ry="3" width="121" height="16" />
    </ContentLoader>
);

export default Loader;
